import { isDocumentRelatedToQuote, type RelationDoc } from "./document-relations";

/** Extra CRM fields present on synced rows but not on minimal RelationDoc. */
type DocWithTimestamps = RelationDoc & {
  created_at?: string | null;
  generated_at?: string | null;
  document_date?: string | null;
  last_synced_at?: string | null;
};

function depositRecencyTimestamp(doc: RelationDoc): number {
  const d = doc as DocWithTimestamps;
  const candidates: unknown[] = [
    d.created_at,
    d.generated_at,
    d.document_date,
    d.last_synced_at,
  ];
  let max = 0;
  for (const c of candidates) {
    if (c == null || c === "") continue;
    const t = new Date(String(c)).getTime();
    if (Number.isFinite(t) && t > max) max = t;
  }
  return max;
}

/**
 * Quote id for the Cenová ponuka from which the most recently created
 * zálohová faktúra (deposit_invoice or proforma) in `allDocs` was generated.
 * Used as the deal anchor when multiple quotes exist.
 */
export function resolveQuoteIdFromLatestDeposit(
  quotes: ReadonlyArray<RelationDoc>,
  allDocs: ReadonlyArray<RelationDoc>,
): string | null {
  const deposits = allDocs.filter(
    (d) =>
      d.document_type === "deposit_invoice" || d.document_type === "proforma",
  );
  if (deposits.length === 0 || quotes.length === 0) return null;

  const sorted = deposits.slice().sort((a, b) => {
    const tb = depositRecencyTimestamp(b);
    const ta = depositRecencyTimestamp(a);
    if (tb !== ta) return tb - ta;
    return b.id.localeCompare(a.id);
  });

  for (const dep of sorted) {
    for (const q of quotes) {
      if (q.id === dep.id) continue;
      const qNum = q.document_number ?? q.sf_document_id;
      const qSf = q.sf_document_id ?? undefined;
      if (isDocumentRelatedToQuote(dep, q.id, qNum, qSf)) {
        return q.id;
      }
    }
  }
  return null;
}
